var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDataInterconnect(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 13,
    viewBox: "0 0 16 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.875 0.5C10.4844 0.5 11 1.01562 11 1.625V3.875C11 4.50781 10.4844 5 9.875 5H8.75V5.75H14.75C15.1484 5.75 15.5 6.10156 15.5 6.5C15.5 6.92188 15.1484 7.25 14.75 7.25H12.5V8H13.625C14.2344 8 14.75 8.51562 14.75 9.125V11.375C14.75 12.0078 14.2344 12.5 13.625 12.5H9.875C9.24219 12.5 8.75 12.0078 8.75 11.375V9.125C8.75 8.51562 9.24219 8 9.875 8H11V7.25H5V8H6.125C6.73438 8 7.25 8.51562 7.25 9.125V11.375C7.25 12.0078 6.73438 12.5 6.125 12.5H2.375C1.74219 12.5 1.25 12.0078 1.25 11.375V9.125C1.25 8.51562 1.74219 8 2.375 8H3.5V7.25H1.25C0.828125 7.25 0.5 6.92188 0.5 6.5C0.5 6.10156 0.828125 5.75 1.25 5.75H7.25V5H6.125C5.49219 5 5 4.50781 5 3.875V1.625C5 1.01562 5.49219 0.5 6.125 0.5H9.875ZM6.5 2V3.5H9.5V2H6.5ZM5.75 11V9.5H2.75V11H5.75ZM10.25 9.5V11H13.25V9.5H10.25Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDataInterconnect);
export default __webpack_public_path__ + "static/media/IconDataInterconnect.99ea640c2fee2220844b37b9528a5a79.svg";
export { ForwardRef as ReactComponent };